export const TYPES = {
  FLOW_MAX_UPDATE: 'QAFLOW/FLOW_MAX_UPDATE',
  PAGE_LEVEL_ERROR: 'QAFLOW/PAGE_LEVEL_ERROR',
  UPDATE_TO_NEW_QA: 'QAFLOW/UPDATE_TO_NEW_QA',
  UPDATE_PRICE: 'QAFLOW/UPDATE_PRICE',
  ADD_ANSWER: 'QAFLOW/ADD_ANSWER',
  SET_BASE_SKU_INFORMATION: 'QAFLOW/SET_BASE_SKU_INFORMATION',
  GO_BACK: 'QAFLOW/GO_BACK',
  ADD_TEMP_ANSWER_TO_QUE: 'QAFLOW/ADD_TEMP_ANSWER_TO_QUE',
  REMOVE_TEMP_ANSWER_TO_QUE: 'QAFLOW/REMOVE_TEMP_ANSWER_TO_QUE',
  UPDATE_CURRENT_LOCATION_SEARCH: 'QAFLOW/UPDATE_CURRENT_LOCATION_SEARCH',
};

/* ************** UPDATERS ************ */
/**
 * This sets the current question & answer object display
 * @param qa
 * @returns {{payload: {qa: *}, type: *}}
 */
export function updateToNewQA(qa) {
  return {
    type: TYPES.UPDATE_TO_NEW_QA,
    payload: {
      qa,
      group: qa.group,
    },
  };
}

export function updatePrice() {
  return {
    type: TYPES.UPDATE_PRICE,
  };
}

export function goBack() {
  return {
    type: TYPES.GO_BACK,
  };
}

export function removeTempAnswerToQue(id) {
  return {
    type: TYPES.REMOVE_TEMP_ANSWER_TO_QUE,
    payload: {
      id,
    },
  };
}

/* ******** ADD ************ */
export function addAnswer(answer) {
  return {
    type: TYPES.ADD_ANSWER,
    payload: {
      answer,
    },
  };
}

export function addBaseSkuInformation({ skuName, skuBasePrice, maxFlow = 0 }) {
  return {
    type: TYPES.SET_BASE_SKU_INFORMATION,
    payload: {
      skuBasePrice,
      skuName,
      maxFlow,
    },
  };
}

export function addTempAnswerToQue(queObject) {
  return {
    type: TYPES.ADD_TEMP_ANSWER_TO_QUE,
    payload: {
      queObject,
    },
  };
}
/* ******** ERROR ************ */
/**
 * Catastrophic error. Page is not useable. What do we want to do?
 *
 * @param error
 * @returns {{payload: {error: *}, type: *}}
 */
export function pageLevelErrorAction(error) {
  return {
    type: TYPES.PAGE_LEVEL_ERROR,
    payload: {
      error,
    },
  };
}
